[
  {
    "indexAffix": "",
    "label": "Suosittelemme",
    "urlValue": "suosittelemme"
  },
  {
    "indexAffix": "_replica_sort_newest",
    "label": "Uusin ensin",
    "urlValue": "uusin-ensin"
  },
  {
    "indexAffix": "_replica_sort_name_default_asc",
    "label": "Nimen mukaan",
    "urlValue": "nimen-mukaan"
  },
  {
    "indexAffix": "_replica_sort_finalprice_asc",
    "label": "Edullisin ensin",
    "urlValue": "edullisin-ensin"
  },
  {
    "indexAffix": "_replica_sort_finalprice_desc",
    "label": "Kallein ensin",
    "urlValue": "kallein-ensin"
  },
  {
    "indexAffix": "_replica_sort_reviews_desc",
    "label": "Parhaiten arvostellut",
    "urlValue": "parhaiten-arvostellut"
  }
]
